export default function (axios) {
  return {
    // 获取常用菜单栏
    getDefaultMenu(params) {
      return axios.post("/cAccountAuthCtl/selectDefaultMenu", params);
    },

    // 常用菜单栏变更
    updateMenu(params) {
      return axios.post("/cAccountAuthCtl/updateDefaultAuth", params);
    },

    // //个人会员查询
    getPerInfoReq(params) {
      return axios.get("/userMember/selectById", params);
    },

    // //个人会员修改
    updateUserMember(params) {
      return axios.post("/userMember/updateUserMember", params, {
        ContentType: "application/json;charset=UTF-8",
      });
    },

    //保存渠道合作数据
    addApplyAgentNose(params) {
      return axios.post("/applyAgent/addApplyAgentNose", params);
    },
  }
}